import { SerpSearchResult } from 'types/utility';
import { useTheme } from '@mui/material/styles';
import { Avatar, Stack, Typography, Grid } from '@mui/material';
import { actionButtonSpacing } from 'constants/themeConstants';
import SegmentButton from 'ui-component/Segment/SegmentButton';
import { IconCheck, IconExternalLink } from '@tabler/icons-react';
import InlineGoToButton from 'ui-component/shared/InlineGoToButton';

const SerpResultRow = ({
  result,
  onClick,
}: {
  result: SerpSearchResult;
  onClick: () => void;
}) => {
  const theme = useTheme();
  return (
    <Grid
      key={result.link}
      container
      size={12}
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      onClick={onClick}
      sx={{
        padding: theme.spacing(1, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <Grid container size={10}>
        <Grid size={12}>
          <Stack
            direction="row"
            spacing={actionButtonSpacing}
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Avatar
              src={`https://s2.googleusercontent.com/s2/favicons?domain=${result.link}&sz=128`}
              sx={{ width: 36, height: 36 }}
            />
            <Stack
              direction="column"
              sx={{
                justifyContent: 'center',
                alignItems: 'flex-start',
              }}
            >
              <Typography variant="h5">{result.title}</Typography>
              <Typography variant="caption">{result.link}</Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid size={12} sx={{ mt: 0.5 }}>
          <Typography>{result.description}</Typography>
        </Grid>
      </Grid>
      <Grid container size={2} justifyContent="flex-end">
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <SegmentButton
            variant="contained"
            color="primary"
            onClick={onClick}
            startIcon={<IconCheck />}
          >
            Select
          </SegmentButton>
          <InlineGoToButton
            link={result.link}
            tooltip="View Website"
            recordName="Website"
            Icon={IconExternalLink}
            isExternalLink
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SerpResultRow;
